import Cancel from '@mui/icons-material/Cancel';
import SaveIcon from '@mui/icons-material/Save';
import { Divider, Grid, Typography } from '@mui/material';
import { ValidationErrors } from 'fluentvalidation-ts';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import CustomButton from '../../../../Common/Components/Controls/InputControls';
import { Loader } from '../../../../Common/Components/Loader';
import {
  FooterContainer,
  FooterWrapper,
  PaperWrapper,
} from '../../Common/CommonComponents';
import { OperationType, SqlServer } from '../Model/SqlServerModel';
import { sqlServerService } from '../SqlServerService';
import SqlServerCreateForm from './SqlServerForm';
import { showToast } from '../../../../lib/toast';

interface Param {
  sqlserver: string;
}

export default function SqlServerEdit() {
  const params = useParams<Param>();
  const [loading, setLoading] = useState(0);
  const history = useHistory();
  const [errors, setErrors] = useState<ValidationErrors<SqlServer>>({});
  const [sqlServer, setSqlServer] = useState<SqlServer>({
    AdminPassword: '',
    UserName: '',
    ServerName: '',
    ResourceGroup: '',
    Subscription: '',
    ProductID: '',
    Role: 'primary',
    Region: 'northeurope',
    EnableElasticPool: true,
    TenantCount: 0,
    DataMaxSize: 50,
    EDtu: 50,
    PerDbDtu: 10,
    FailoverGroups: [],
  });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = event.target;
    if (type === 'checkbox') {
      setSqlServer({
        ...sqlServer,
        [name]: checked,
      });
    } else {
      setSqlServer({
        ...sqlServer,
        [name]: value,
      });
    }
  };

  const validate = () => {
    if (Object.keys(errors).length > 0) {
      Object.entries(errors).forEach(([key, value]) => {
        showToast({
          type: 'error',
          title: key + ' ' + value?.toString(),
        });
      });
      return false;
    }
    return true;
  };

  const cancel = () => {
    history.push('/sqlserver');
  };

  const saveSqlServer = () => {
    setLoading((prevState) => prevState + 1);
    if (validate()) {
      sqlServerService
        .addSqlServer(sqlServer.ServerName, sqlServer)
        .then((result) => {
          showToast({
            type: 'success',
            title: result.ServerName + ' updated successfully',
          });
          cancel();
        })
        .catch((err) => {
          showToast({
            type: 'error',
            title: 'Failed to add Sql Server',
          });
          console.log(err);
        });
    }
    setLoading((prevState) => prevState - 1);
  };

  const loadSqlServer = async () => {
    try {
      setLoading(loading + 1);
      const sqlserver = await sqlServerService.getSqlServer(params.sqlserver);
      setSqlServer(sqlserver);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(loading - 1);
    }
  };

  useEffect(() => {
    InitData();
  }, []);

  const InitData = async () => {
    await loadSqlServer().catch((err) => console.log(err));
  };

  return (
    <>
      <Loader loading={loading > 0} />
      <div>
        <PaperWrapper>
          <Typography variant="h5" sx={{ mb: 2 }}>
            Edit Sql Server
          </Typography>
          <Divider sx={{ mb: 3 }} />
          <SqlServerCreateForm
            onFieldChange={handleChange}
            sqlserver={sqlServer}
            errors={errors}
            setErrors={setErrors}
            setSqlServer={setSqlServer}
            sqlServerOperation={OperationType.Edit}
          />
          <FooterWrapper>
            <FooterContainer>
              <Grid item xs={12} sm="auto">
                <CustomButton
                  onClick={saveSqlServer}
                  startIcon={<SaveIcon />}
                  label="Save"
                />
              </Grid>
              <Grid item xs={12} sm="auto">
                <CustomButton
                  onClick={cancel}
                  startIcon={<Cancel />}
                  label="Cancel"
                />
              </Grid>
            </FooterContainer>
          </FooterWrapper>
        </PaperWrapper>
      </div>
    </>
  );
}
